<template>
  <div class="is-relative is-height-100p-50px">
    <div>
      <AppHeader/>
    </div>
    <b-autocomplete
      v-model="search"
      :data="filtreRecoms"
      placeholder="Recherche un point de vente"
      icon="magnify"
      clearable
      field="libelle"
      @select="accessRecom($event)">
      <template slot="empty">Aucune recommandation trouvée</template>
    </b-autocomplete>
    <CartoGeneral/>
    <router-view/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Header from '@/components/general/Header';
import CartoGeneral from '@/components/portailGroupe/CartoGeneral';
import userConfig from '@/configurations/userConfig';

const User = createNamespacedHelpers('user');
const Groupe = createNamespacedHelpers('groupe');

export default {
  components: {
    AppHeader: Header,
    CartoGeneral,
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...Groupe.mapState({
      recoms: 'recoms',
    }),
    filtreRecoms() {
      if (this.$route.name === 'ListePointDeVente') {
        return this.recoms
          .map(recom => ({
            libelle: recom.data.pointDeVentes[0].libelle,
            previewLink: recom.previewLink,
            idEnseigne: recom.data.pointDeVentes[0].idEnseigne
          }))
          .filter(pdv => pdv.idEnseigne === this.$route.params.id && pdv.libelle
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0);
      }
      return this.recoms
        .map(recom => ({
          libelle: recom.data.pointDeVentes[0].libelle,
          previewLink: recom.previewLink,
        }))
        .filter((pdv) => {
        return pdv.libelle
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) >= 0
      });
    }
  },
  methods: {
    ...User.mapActions({
      logIn: 'logIn',
    }),
    ...Groupe.mapActions({
      getRecomsGroupe: 'getRecomsGroupe',
    }),
    accessRecom(data){
      window.open(data.previewLink);
    }
  },
  async mounted() {
    if (this.recoms.length) return;
    const loadingComponent = this.$buefy.loading.open({ container: null });
    try {
      await this.logIn(userConfig);
      await this.getRecomsGroupe();
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
